<template>
    <div class="container pt-2">
        <PageTitle main="Configurações" sub="Cadastrar, alterar ou deletar Configurações" />
        <b-form>
            <input id="config-id" type="hidden" v-model="config.id" />
            <div class="row">
                <div class="col-md-6">
                    <b-form-group label="Chave:" label-for="config-titulo">
                        <b-form-input id="config-titulo" type="text"
                            v-model="config.titulo"
                            :class="{ 'inputError': $v.config.titulo.$error }"
                            @keydown.tab="$v.config.titulo.$touch"/>
                        <span class="error" v-if="!$v.config.titulo.required && $v.config.titulo.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.config.titulo.minLength && $v.config.titulo.$error">Precisa ter no mínimo 2 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group label="Valor:" label-for="config-valor">
                        <b-form-input id="config-valor" type="text"
                            v-model="config.valor"
                            :class="{ 'inputError': $v.config.valor.$error }"
                            @keydown.tab="$v.config.valor.$touch"/>
                        <span class="error" v-if="!$v.config.valor.required && $v.config.valor.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.config.valor.minLength && $v.config.valor.$error">Precisa ter no mínimo 2 letras!</span>
                    </b-form-group>
                </div>
            </div>
            <b-button variant="outline-success" class="btn-custom" @click="save">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 btn-custom" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-configs" 
                class="text-center table table-sm" 
                :items="configs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadConfig(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-configs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-configs" 
                class="text-center table table-sm" 
                :items="configs" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadConfig(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-configs"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mask } from 'vue-the-mask'
import { required, minLength } from 'vuelidate/lib/validators'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'configs',
    components: { PageTitle },
    directives: { mask },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            config: {},
            configs: [],
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            fields: [
                { key: 'titulo', label: 'Chave', sortable: true },
                { key: 'valor', label: 'Valor', sortable: true },
                { key: 'dataAtualizacao', label: 'Atualizado em', formatter: 'formatData', thStyle: { width: '20%' } },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' } }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    computed: {
        rows() {
            return this.configs.length
        }
      },
        validations: {
        config: {
            titulo: {
                required,
                minLength: minLength(2)
            },
            valor: {
                required,
                minLength: minLength(2)
            }
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        formatData(data) {
            const arr = data.split('-')
            const y = arr[0]
            const m = arr[1]
            const d = arr[2]
            return `${d}/${m}/${y}`
        },
        loadConfigs() {
            const url = `${baseApiUrl}/backend/SELECT/configs.php`
            axios.get(url).then(res => {
                this.configs = res.data
                this.exibeRodape = false
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.exibeRodape = true
            }
            )
        },
        reset() {
            this.config = {}
            this.loadConfigs()
            this.$v.config.$reset()
        },
        save() {
            this.$v.config.$touch()
            if(!this.$v.config.$error){
                const method = this.config.id ? 'put' : 'post'
                const id = this.config.id ? `?id=${this.config.id}` : ''
                if(method==='post'){
                    axios['post'](`${baseApiUrl}/backend/INSERT/configs.php${id}`, this.config)
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Configuração inserida com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                } else {
                    axios['put'](`${baseApiUrl}/backend/UPDATE/configs.php${id}`, this.config)
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Configuração alterada com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                }
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(config) {
            const sure = confirm("Deseja realmente excluir a configuração?")
            if(sure === true){
                if(config.name === 'SystemTitle') {
                    this.$toasted.global.defaultError({ message : 'Item não passível de exclusão!' })
                } else if(config.name === 'PrefixTrack') {
                    this.$toasted.global.defaultError({ message : 'Item não passível de exclusão!' })
                } else if(config.name === 'SufixTrack') {
                    this.$toasted.global.defaultError({ message : 'Item não passível de exclusão!' })
                } else if(config.name === 'CurrTrack') {
                    this.$toasted.global.defaultError({ message : 'Item não passível de exclusão!' })
                } else if(config.name === 'InitTrack') {
                    this.$toasted.global.defaultError({ message : 'Item não passível de exclusão!' })
                } else {
                    const url = `${baseApiUrl}/backend/DELETE/configs.php`
                    axios.delete(url, { data: config })
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Configuração excluída com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                }
            }
        },
        loadConfig(config) {
            this.config = { ...config }
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.nivel !== 'admin') {
            this.$router.push('/')
        }
        this.loadConfigs()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.configs.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

#config-titulo, #config-valor {
    /* border: 0; */
    outline: 0;
    border-radius: 10px;
    /* border-bottom: 1px solid #AAA; */
    background-color: rgba(255,255,255,0.4);
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.text-custom {
    font-size: 0.8rem;
}

.btn-custom {
    border-radius: 10px;
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
    background-color: rgba(255,255,255,0.4);
}
</style>